import Vue from 'vue'
import Router from 'vue-router'
import RepositoryService from '@/services/repositoryService'
import Login from '@/components/views/authentication/login.vue'
import SelectBillingCompany from '@/components/views/authentication/select-billing-company.vue'
import CreateIntegrator from '@/components/views/integration/create-integrator.vue'
import ListIntegrators from '@/components/views/integration/list-integrator.vue'
import CreateTestFacility from '@/components/views/integration/create-test-facility.vue'
import CreateTestChain from '@/components/views/integration/create-test-chain.vue'
import IntegratedFacilities from '@/components/views/integration/integrated-facilities.vue'
import Searchfacility from '@/components/views/facility/search-facility.vue'
import Searchchain from '@/components/views/chain/search-chain.vue'
import ChainMenu from '@/components/views/chain/chain-menu.vue'
import FacilityMenu from '@/components/views/facility/facility-menu.vue'
import ConvertAccount from '@/components/views/account/convert-account.vue'
import NotFound from '@/components/views/404.vue'
// import { i18n } from '@/plugins/i18n.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: { name: 'login' }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false, requestBilligCompany: false, hasMenu: false, showFullScreen: false }
    },
    {
      path: '/selectbillingcompany',
      name: 'selectbillingcompany',
      component: SelectBillingCompany,
      meta: { requiresAuth: true,
        requestBilligCompany: false,
        hasMenu: false,
        showFullScreen: false
      }
    },
    {
      path: '/createintegrator',
      name: 'createintegrator',
      component: CreateIntegrator,
      meta: { requiresAuth: true, requestBilligCompany: false, hasMenu: false, showFullScreen: false }
    },
    {
      path: '/createtestfacility',
      name: 'createtestfacility',
      component: CreateTestFacility,
      meta: { requiresAuth: true, requestBilligCompany: true, hasMenu: false, showFullScreen: false }
    },
    {
      path: '/createtestchain',
      name: 'createtestchain',
      component: CreateTestChain,
      meta: { requiresAuth: true, requestBilligCompany: true, hasMenu: false, showFullScreen: false }
    },
    {
      path: '/searchfacility',
      name: 'searchfacility',
      component: Searchfacility,
      meta: { requiresAuth: true,
        requestBilligCompany: true,
        hasMenu: false,
        showFullScreen: false
      }
    },
    {
      path: '/listIntegrators',
      name: 'listIntegrators',
      component: ListIntegrators,
      meta: { requiresAuth: true, requestBilligCompany: true, hasMenu: false, showFullScreen: false }
    },
    {
      path: '/integratedfacilities',
      name: 'integratedfacilities',
      component: IntegratedFacilities,
      meta: { requiresAuth: true, requestBilligCompany: true, hasMenu: false, showFullScreen: false }
    },
    {
      path: '/searchchain',
      name: 'searchchain',
      component: Searchchain,
      meta: { requiresAuth: true,
        requestBilligCompany: true,
        hasMenu: false,
        showFullScreen: false
      }
    },
    {
      path: '/facilityMenu',
      name: 'facilitymenu',
      component: FacilityMenu,
      meta: { requiresAuth: true,
        requestBilligCompany: true,
        requestSelectedFacility: true,
        hasMenu: false,
        showFullScreen: false
      }
    },
    {
      path: '/chainMenu',
      name: 'chainmenu',
      component: ChainMenu,
      meta: { requiresAuth: true, requestBilligCompany: true, requestSelectedFacility: true, hasMenu: false, showFullScreen: false }
    },
    {
      path: '/convertaccount',
      name: 'convertaccount',
      component: ConvertAccount,
      meta: { requiresAuth: true, hasMenu: false, showFullScreen: false }
    },
    {
      // not found handler
      path: '*',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!RepositoryService.session.isUserLoggedIn()) {
      return next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  }
  if (to.matched.some(record => record.meta.requestBilligCompany)) {
    if (!RepositoryService.session.isUserLoggedInWithBillingCompany()) {
      return next({
        path: '/selectbillingcompany',
        query: { redirect: to.fullPath }
      })
    }
  }
  if (to.matched.some(record => record.meta.requestSelectedFacility)) {
    if (!RepositoryService.session.isUserLoggedInWithSelectedFacility()) {
      return next({
        path: '/searchfacility',
        query: { redirect: to.fullPath }
      })
    }
  }
  next()
})

// router.beforeEnter((to, from, next) => {
//   const lang = to.params.lang
//   if (!['en', 'it'].includes(lang)) return next('en')

//   if (i18n.locale === lang) return next()

//   import(`@/lang/${lang}.json`).then((msgs) => {
//     i18n.setLocaleMessage(lang, msgs.default || msgs)
//     i18n.locale = lang
//     return next()
//   })
// })

export default router
